(() => {
  const root = document;
  const topBtn = root.querySelector('[data-scroll-top]');
  if (!topBtn) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const threshold = 320;

  const setVisibility = () => {
    const shouldShow = window.scrollY > threshold;
    topBtn.classList.toggle('is-hidden', !shouldShow);
    topBtn.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  };

  const onScrollTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
    });
  };

  topBtn.addEventListener('click', onScrollTop);
  window.addEventListener('scroll', setVisibility, { passive: true });
  window.addEventListener('load', setVisibility, { passive: true });
  setVisibility();
})();

